import * as React from 'react';
import { FormState, FieldState } from 'formstate';
import * as addHours from 'date-fns/add_hours';
import * as addDays from 'date-fns/add_days';
import * as addWeeks from 'date-fns/add_weeks';
import * as addMonths from 'date-fns/add_months';

// Utilities
import { required, between } from '../../utilities/validation';

// FormState
class QuestionDialogCreateFormState {
  // Create a field
  description = new FieldState('')
    .disableAutoValidation()
    .validators(required, between(0, 250));
  duration = new FieldState('1h').disableAutoValidation().validators(required);

  // Compose fields into a form
  state = new FormState({
    firstName: this.description,
    duration: this.duration
  });

  getValues() {
    return {
      firstName: this.description.$,
      duration: this.duration.$
    };
  }
}

// Components
import Box from '../../components/Box';
import Divider from '../../components/Divider';
import { TextField, RadioGroup } from '../../components/FormStateFields';
import Typography from '../../components/Typography';

// Component
interface IProps {
  formState: QuestionDialogCreateFormState;
  onSubmit: React.FormEventHandler<HTMLFormElement>;
}

const QuestionDialogCreateForm = (props: IProps) => {
  return (
    <div>
      <Box pa={3}>
        <Typography type={'title'}>Question</Typography>
      </Box>
      <Divider />
      <form onSubmit={props.onSubmit}>
        <Box pa={3}>
          <TextField
            fieldState={props.formState.description}
            label="Question"
            type="text"
            required={true}
            margin="normal"
            fullWidth={true}
            multiline={true}
            autoFocus={true}
          />
          <RadioGroup
            label={'Duration'}
            name="duration"
            fieldState={props.formState.duration}
            row={true}
            options={[
              { value: '1h', label: '1 Hour' },
              { value: '1d', label: '1 Day' },
              { value: '3d', label: '3 Day' },
              { value: '1w', label: '1 Week' },
              { value: '1m', label: '1 Month' }
            ]}
          />
        </Box>
        <button style={{ opacity: 0, position: 'absolute' }} type="submit" />
      </form>
    </div>
  );
};

// Helpers

function convertDurationValue(durationValue: string): [Date, Date] {
  const now = new Date();

  switch (durationValue) {
    case '1h':
      return [now, addHours(now, 1)];
    case '1d':
      return [now, addDays(now, 1)];
    case '3d':
      return [now, addDays(now, 3)];
    case '1w':
      return [now, addWeeks(now, 1)];
    case '1m':
      return [now, addMonths(now, 1)];
    // TODO: hotfix for unreachable code
    default:
      return [now, now];
  }
}

// Exports
export { QuestionDialogCreateFormState, convertDurationValue };
export default QuestionDialogCreateForm;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/AppNetworkPeopleSearch/QuestionDialogCreateForm.tsx